import { Injectable } from "@angular/core";
import { Table } from "primeng/table";
import { Observable, Subject } from "rxjs";

@Injectable({
  providedIn: 'any'
})
export class AvanoTableFilteringService {
  private table: Table;

  private resetFilters = new Subject<void>();
  public resetFilters$: Observable<void> = this.resetFilters.asObservable();

  public init(table: Table): void {
    this.table = table;
  }

  public resetAllFilters(): void {
    this.resetFilters.next();
  }

  public applyFilter(filterValue: string, filterField: string, filterMatchMode: string): void {
    if (!this.table) {
      console.error("Service not initialized!")
      return;
    }
    this.table.filter(filterValue, filterField, filterMatchMode)
  }
}